import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  Button,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useSelector } from "react-redux";
import { lgDocPath } from "../../../../../constants/languageDocPaths";

function RegExRangeType(props) {
  const { t } = useTranslation();
  const queryParams = useSelector((state) => state.queryParams);
  const [regExSummaryModal, setRegExSummaryModal] = useState(false);
  let docPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/regex.html`;

  return (
    <>
      <FormControl className="width-100" size="small">
        <div className="flex">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_RANGE_EXPRESSION")}
            className={"width-100"}
            type="text"
            value={props.RANGE_EXPRESSION}
            name="RANGE_EXPRESSION"
            onChange={(e) => props.RegEX(e.target)}
          />
          <Button
            variant="outlined"
            size="small"
            disableElevation
            className="margin-left-4"
            sx={{
              width: "40px",
              padding: "4px 8px",
              minWidth: "40px",
            }}
            onClick={() => setRegExSummaryModal(true)}>
            <MoreHorizIcon fontSize="small" />
          </Button>
        </div>
      </FormControl>

      {/* Regular expression summary modal */}
      <Dialog open={regExSummaryModal} maxWidth={"md"} fullWidth={true}>
        <DialogTitle className="dialog-header">
          <div className="title">{t("TIT_BG_CLIENT")}</div>
        </DialogTitle>
        <DialogContent
          className="dialog-content"
          sx={{ height: 780, maxHeight: 780, overflow: "hidden" }}
          dividers>
          {docPath ? (
            <iframe
              className="docFrame"
              title="RegExDocs"
              src={docPath}></iframe>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions className="dp-actions">
          <Button
            size="small"
            onClick={() => setRegExSummaryModal(!regExSummaryModal)}
            variant={"outlined"}>
            {t("BTN_CLOSE")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RegExRangeType;
